import React, { useContext } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { includes, isEmpty } from 'lodash';
import parse from 'html-react-parser';
import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';
import { VisitFeature, ImgCenter } from './styles/VisitFeature.styled';
import { Container } from './styles/Container.styled';
import { Row } from './styles/Row.styled';
import { Column, ColumnXlSevenLgSix, Innercontent, Innercontentp } from './styles/Column.styled';
import { ReadMore, ReadMoreWrapper } from './styles/AboutVenue.styled';
import { Button } from './styles/Button.styled';

export default function TwoColumnsTextImage({ data, id, dir }) {
  const { header, paragraphs, image, imageOnLeft, greyBackground, jumpToSection, link, darkCTA} = data;
  const [readMore, setReadMore] = React.useState(false);

  const { translations } = useContext(DWTCContext);

  const textLess = getTranslationByKey(translations, '-Read Less');
  const textMore = getTranslationByKey(translations, '+Read More');
  const readMoreLabel = readMore ? textLess : textMore;

  const { cssClass } = React.useContext(DWTCContext);
  const [buttonTheme, setButtonTheme] = React.useState('');

  React.useEffect(() => {
    if (includes(cssClass, 'free-zone')) setButtonTheme('red');
    else if (includes(cssClass, 'real-estate')) setButtonTheme('green');
    else setButtonTheme('secondary');
  }, []);

  const btnPosition = link ? 'btn-position' : '';
  const btnPositionS = link ? 'btn-static' : '';

  const columnBtn = link ? (
    <div className="cta-wrapper">
      <Button
        stylevariant={buttonTheme}
        href={link.url}
        target={link.target}
        rel=""
        className={!darkCTA && 'btn-outline'}
        dir={dir}
      >
        {link.name}
      </Button>
    </div>
  ) : null;

  return (
    <div id={jumpToSection}>
      <VisitFeature id={id} className={greyBackground && 'bg_gray'}>
        <Container className={btnPosition}>
          <Row className={imageOnLeft && 'position_left'}>
            <Column className={btnPositionS}>
              <Innercontent dir={dir} className="text-content">
                <h3 dir={dir} className='mb-5 leading-1.5'>{header}</h3>
                <div className={darkCTA && 'dark-text'}>
                {paragraphs.map((paragraph, index) => (
                  <Innercontentp dir={dir} toggle={readMore} className={index && 'toggle'}>
                    {parse(paragraph)}
                  </Innercontentp>
                ))}
                </div>
                {paragraphs.length > 1 && (
                  <ReadMoreWrapper>
                    <ReadMore dir={dir} onClick={() => setReadMore(!readMore)}>
                      {readMoreLabel}
                    </ReadMore>
                  </ReadMoreWrapper>
                )}
                {columnBtn}
              </Innercontent>
            </Column>
            <ColumnXlSevenLgSix>
              <ImgCenter>
                {isEmpty(image) || (
                  <LazyLoadImage
                    width={682}
                    src={image.url}
                    alt="Visit Image Dubai"
                    placeholderSrc={image ? `${image.url}?width=50&quality=50` : null}
                    effect="blur"
                  />
                )}
              </ImgCenter>
            </ColumnXlSevenLgSix>
          </Row>
        </Container>
      </VisitFeature>
    </div>
  );
}
